import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Icon } from '../components/Icon.tsx';
import axios from 'axios';
import { dv } from '../i18n/dv.ts';

export function ForgotPassword(): JSX.Element {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 429) {
        setError(dv.common.error);
      } else {
        setError(dv.common.error);
      }
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="mx-auto max-w-sm px-4 py-12">
      <div className="rounded-3xl bg-[hsl(var(--chrome))] p-6 lg:p-7 space-y-6">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight">{dv.auth.resetPassword}</h1>
          <p className="text-sm text-muted-foreground">
            {dv.auth.forgotPassword}
          </p>
        </div>
        {sent ? (
          <div className="space-y-4">
            <div className="flex items-start gap-3 rounded-2xl bg-[hsl(var(--success-container))] px-4 py-3 text-sm text-[hsl(var(--on-success-container))]" role="status">
              <Icon name="mark_email_read" size={20} className="shrink-0" />
              <span>{dv.auth.resetSent}</span>
            </div>
            <Link to="/login" className="btn-ghost btn-sm">{dv.common.back}</Link>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={submit}>
            <div className="space-y-1.5">
              <label htmlFor="fp-email" className="field-label">{dv.auth.email}</label>
              <input
                id="fp-email"
                className="input"
                type="email"
                dir="ltr"
                aria-label={dv.auth.email}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {error && (
              <div role="alert" className="rounded-2xl bg-[hsl(var(--error-container))] px-3.5 py-2.5 text-sm text-destructive">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={pending}
              className="btn-primary w-full"
            >
              {pending ? dv.common.loading : dv.auth.sendResetLink}
            </button>
            <Link to="/login" className="block text-center text-sm text-muted-foreground underline underline-offset-4">
              {dv.common.back}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
